SupportCommonBaseView = require('./common_base_view')

class SupportCommonBaseInputsView extends SupportCommonBaseView

  initialize: (options) ->
    @options = options || {}
    @inputViews = []

  renderInputViews: (objects, componentListElement) ->
    for obj in objects
      view = @getViewByObjectType(obj)
      unless view then continue
      @inputViews.push view
      view.render()
      @$el.find(componentListElement).append(view.el)

  isInputValid: ->
    for view in @inputViews
      unless view.isInputValid()
        return false
    true

  collectInputFromComponents: (data)->
    for view in @inputViews
      view.populateInput(data)
    data

  isRequiredInputGiven: ()->
    for view in @inputViews
      if view.isInputCompulsory && !view.isInputGiven()
        return false
    true

  validateEmailForm: =>
    if @isRequiredInputGiven()
      @enableSubmit()
    else
      @disableSubmit()

  onSubmitClick: ->
    @disableSubmit()
    if @isInputValid()
      data = @getFormData()
      @submitForm(data)
    else
      @validateEmailForm()

  getFormData: ->
    data = @model.getBasicTicketData()
    @collectInputFromComponents(data)
    data

  enableSubmit: ->
    $('.submit-button', @$el).removeClass('disabled')
    $('.submit-button', @$el).attr('disabled',false)

  disableSubmit: ->
    $('.submit-button', @$el).addClass('disabled')
    $('.submit-button', @$el).attr('disabled',true)

  getViewByObjectType : () ->

module.exports = SupportCommonBaseInputsView
